import { NgModule } from "@angular/core";
import { UploadLogoDialog } from "src/org-settings/upload-logo.dialog";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { SharedTranslateModule } from "./shared-translate.module";
import { SpinnerModule } from "./spinner.module";
import { StorageService } from "src/services/storage-service";
import { MaterialModule } from "./material.module";

@NgModule({
    imports: [
        FormsModule,
        CommonModule,
        MaterialModule,
        SharedTranslateModule,
        SpinnerModule
    ],  
    declarations: [
        UploadLogoDialog
    ],
    entryComponents: [
        UploadLogoDialog
        ], 
    exports: [
        UploadLogoDialog
    ],
    providers: [
        StorageService
    ]
})
export class UploadImageModule {

}